import { render, staticRenderFns } from "./examination.vue?vue&type=template&id=555fb0dd&scoped=true&"
import script from "./examination.vue?vue&type=script&lang=js&"
export * from "./examination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555fb0dd",
  null
  
)

export default component.exports